import {Alert, Button, Col, Form, Row} from "react-bootstrap";
import React, {useState} from "react";


import {importMembers} from "../../../Api/Members/MembersFetch";


const MembersImport = ({setInvalidRecords, setSuccessMessage, setValidationDatas, setIsLoading, loading}) => {

    const [message, setMessage] = useState();
    const [errors, setErrors] = useState();
    const [selectedFile, setSelectedFile] = useState(null);
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]); // Imposta il singolo file
        console.log(event.target.files[0]);
    };
    const handleSubmit = (e) => {
        e.preventDefault();

        if (!selectedFile) {
            setErrors("Seleziona un file CSV valido prima di inviare.");
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);
        console.log("Selected file:", selectedFile);
        importMembers({data: formData, setMessage, setErrors, setInvalidRecords, setIsLoading, setSuccessMessage});
    };


    return (
        <>
            {message && (
                <Alert
                    variant={"success"}
                    onClick={() => {
                        setMessage(null);
                    }}
                    dismissible
                >
                    {message}
                </Alert>
            )}
            {errors && typeof errors === "string" && (
                <Alert
                    variant={"danger"}
                    onClick={() => {
                        setErrors(null);
                    }}
                    dismissible
                >
                    {errors}
                </Alert>
            )}

            <Row className={"rounded-3 fs-6 px-0 py-2 mx-0 mt-5 card"}>

                <h2 className={'text-start'}>Importa file</h2>
                <hr className={'mt-2'}/>
                <Form
                    className={"row py-3 text-start "}
                    id={"importForm"}
                    encType={"multipart/form-data"}
                    onSubmit={handleSubmit}
                >
                    <Row className={"align-items-center d-flex"}>
                        <Col md={9}>
                            <Col className={"col-md-12"}>
                                <Form.Control
                                    type="file"
                                    accept=".csv"
                                    className={"form-control-sm w-100"}
                                    name={"file"}
                                    required={true}
                                    onChange={(e) => {
                                        setErrors(null);
                                        const file = e.target.files[0];
                                        if (file) {
                                            const validExtensions = ["csv"];
                                            const fileExtension = file.name
                                                .split(".")
                                                .pop()
                                                .toLowerCase();
                                            if (!validExtensions.includes(fileExtension)) {
                                                setErrors(
                                                    "File non valido! Seleziona un file CSV.",
                                                );

                                                e.target.value = ""; // Clear the file input
                                            }
                                        }
                                        handleFileChange(e);
                                    }}
                                />
                            </Col>
                        </Col>

                        <Col md={3} className={"text-end"}>
                            <Button
                                type="submit"
                                className={
                                    "rounded-5 btn-sm w-100 mt-0 btn text-uppercase bkg-primary border-0"
                                }
                            >
                                Importa
                            </Button>
                        </Col>

                    </Row>
                </Form>

            </Row>
        </>
    );
};

export default MembersImport;
